export enum LogLevel {
    trace = 0,
    debug = 1,
    info = 2,
    warn = 3,
    error = 4
}

export class LoggingService {
    constructor(
        private level: number
    ) { }

    error(message: string | object) {
        if (this.level <= LogLevel.error) {
            console.error(message);
        }
    }

    warn(message: string | object) {
        if (this.level <= LogLevel.warn) {
            console.warn(message);
        }
    }

    info(message: string | object) {
        if (this.level <= LogLevel.info) {
            console.info(message);
        }
    }

    debug(message: string | object) {
        if (this.level <= LogLevel.debug) {
            console.debug(message);
        }
    }

    trace(message: string | object) {
        if (this.level <= LogLevel.trace) {
            console.trace(message);
        }
    }
}

export function createLoggingService(logLevel: LogLevel) {
    return new LoggingService(logLevel);
}
